import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import general from './modules/general'
import coverage from './modules/coverage'
import providers from './modules/providers'

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
	storage: window.localStorage,
	key: 'ah-fibre',
	modules: []
});

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
	modules: {
		general,
		coverage,
		providers,
	},
	strict: debug,
	plugins: [vuexLocal.plugin]
})
